import { avatarColors } from "../discord/discord-theme";

export type ChatAuthor = {
  name: string;
  /** Role color of the username. */
  color: string;
  /** Default-avatar background, or the Elevintia mark for the bot. */
  avatar: string | "elevintia";
  app?: boolean;
  /** Shows the server tag next to the name. */
  tag?: boolean;
};

export type ChatEmbed = {
  color: string;
  author?: ChatAuthor;
  title?: string;
  description?: string;
  fields?: { name: string; value: string }[];
  footer?: string;
};

export type ChatButton = {
  label: string;
  style: "primary" | "secondary" | "success";
};

export type ReactionGlyph = "heart" | "fire" | "tada" | "check";

export type ChatEntry = {
  author: ChatAuthor;
  /** Supports **bold**, @mentions and #channels. */
  text?: string;
  embed?: ChatEmbed;
  buttons?: ChatButton[];
  /** Reactions count up from 1 to `count` after the message lands. */
  reaction?: { glyph: ReactionGlyph; count: number };
  /** Renders the "x used /command" line above a bot reply. */
  command?: { user: ChatAuthor; name: string };
  /** Typed into the composer before it is sent. */
  composed?: boolean;
};

const people = {
  mozu: { name: "mozu", color: "#F47B67", avatar: avatarColors.red, tag: true },
  kapiv: {
    name: "Kapiv",
    color: "#3498DB",
    avatar: avatarColors.blurple,
    tag: true,
  },
  frazzx: { name: "frazzx", color: "#E67E22", avatar: avatarColors.yellow },
  xavier: {
    name: "Xavier",
    color: "#DEFF77",
    avatar: avatarColors.green,
    tag: true,
  },
  seiky: { name: "seiky", color: "#C9A7FF", avatar: avatarColors.pink },
  nova: { name: "nova", color: "#F2F3F5", avatar: avatarColors.grey },
  you: { name: "you", color: "#F2F3F5", avatar: avatarColors.blurple },
  mailon: {
    name: "Mailon",
    color: "#2ECC71",
    avatar: avatarColors.green,
    tag: true,
  },
  ymir: { name: "Ymir", color: "#5CB8FF", avatar: "elevintia", app: true },
} satisfies Record<string, ChatAuthor>;

const brand = "#149CFF";

export const chatSeed: ChatEntry[] = [
  { author: people.xavier, text: "anyone else still hyped from yesterday?" },
  { author: people.mailon, text: "Reminder: event clips go in #highlights" },
  { author: people.mozu, text: "that final round last night was unreal" },
  {
    author: people.kapiv,
    text: "the whole server was in voice, never seen it that packed",
    reaction: { glyph: "fire", count: 24 },
  },
  { author: people.seiky, text: "when's the next one?" },
];

export const chatScript: ChatEntry[] = [
  {
    author: people.ymir,
    embed: {
      color: brand,
      title: "Trivia Night starts in 15 minutes",
      description: "312 members registered. Top 3 win the **Champion** role.",
      footer: "Community Events",
    },
    buttons: [
      { label: "Join Stage", style: "primary" },
      { label: "Remind me", style: "secondary" },
    ],
  },
  {
    author: people.frazzx,
    text: "let's gooo, been studying all week",
    reaction: { glyph: "heart", count: 7 },
  },
  { author: people.you, text: "count me in!", composed: true },
  {
    author: people.ymir,
    text: "GG @frazzx, you just advanced to **level 12**!",
    reaction: { glyph: "tada", count: 6 },
  },
  {
    author: people.ymir,
    command: { user: people.kapiv, name: "rank" },
    embed: {
      color: brand,
      author: people.kapiv,
      fields: [
        { name: "Rank", value: "#14" },
        { name: "Level", value: "23" },
        { name: "XP", value: "4,210 / 5,000" },
      ],
      footer: "790 XP to level 24",
    },
  },
  { author: people.nova, text: "hi everyone, a friend sent me the invite" },
  {
    author: people.ymir,
    text: "Welcome @nova! Grab your roles in #onboarding to unlock the event channels.",
    reaction: { glyph: "heart", count: 9 },
  },
  {
    author: people.ymir,
    command: { user: people.mozu, name: "daily" },
    embed: {
      color: "#23A55A",
      title: "Daily reward claimed",
      description:
        "You received **250 coins**. Come back tomorrow to keep your streak going.",
      footer: "Streak: 6 days",
    },
  },
  {
    author: people.xavier,
    text: "the new roles look so clean btw",
    reaction: { glyph: "check", count: 11 },
  },
  {
    author: people.ymir,
    command: { user: people.seiky, name: "trivia" },
    embed: {
      color: "#FAA61A",
      title: "Question 3 of 10",
      description: "In which year did Discord launch?",
      footer: "First correct answer earns 50 XP",
    },
    buttons: [
      { label: "2014", style: "secondary" },
      { label: "2015", style: "secondary" },
      { label: "2016", style: "secondary" },
    ],
  },
  {
    author: people.mailon,
    text: "no googling, we can tell",
    reaction: { glyph: "fire", count: 5 },
  },
];
